import { useContext } from 'react';
import { FaStar, FaRegStar } from "react-icons/fa";
import { DashboardContext } from '../../context/DashboardContext';

export default function OrdemPrioridade({ corFavorito, DiretrizEstrategica, tab }) {
    const { AdicionarGraficoFavorito } = useContext(DashboardContext)

    let arrayD = []
    DiretrizEstrategica?.map((a) => {
        return (
            a.itens.map((b) => {
                arrayD.push(b)
            })
        )
    })

    const retornaCor = (descricao) => {
        switch (descricao) {
            case "Normal":
                return "#059669"
            case "Importante":
                return "#FACC15"
            case "Prioritária":
                return "#F87171"
            default:
                break;
        }
    }

    return (
        <>
            <h2 className="h2-bsc">
                <button onClick={() => AdicionarGraficoFavorito("Ordem")} className='btn-grafico'>{corFavorito("Ordem") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                <span style={{ fontWeight: '500' }}>Ordem de Prioridade</span>
            </h2>
            <div className="content-prioridade-dash">
                <table style={{ width: '100%' }}>
                    <tbody>
                        {
                            arrayD?.sort((a, b) => a.ordem - b.ordem).map((o, index) => {
                                return (
                                    <tr key={index} className="tr-bsc">
                                        <td className='td-bsc-ordem'>
                                            <div className='ordem' style={{ borderColor: retornaCor(o.diretrizEstrategicaPrioridade.descricao)}}>
                                                <div style={{ backgroundColor: retornaCor(o.diretrizEstrategicaPrioridade.descricao)}}>{o.ordem}º</div>
                                                <div>{o.letra}</div>
                                            </div>
                                            <div>{o.descricao}</div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}